import type { ValueOf } from './util/typeUtils';

export const SUMMARY_ROUTES = {
    BUCKET_LEADS: '/_app/bucketLeads',
    LEADS: '/_app/leads',
} as const;

export type SUMMARY_ROUTE = ValueOf<typeof SUMMARY_ROUTES>;
